import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/autumnFlower/banner.jpg'
import navColor from '../../assets/autumnFlower/nav/color.jpg'
import navBg from '../../assets/autumnFlower/nav/nav_bg.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(108.5),
    backgroundImage: `url(${navColor})`,
    marginTop: calcRemFn(-1),
  },
  navCtn: {
    height: calcRemFn(108.5),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(20)} ${calcRemFn(60)} 0 ${calcRemFn(64)}`
  },
  topBtnBaseCss: {
    width: calcRemFn(58),
    height: calcRemFn(24),
  },
  bottomBtnLayout: {
    flexWrap: 'wrap',
    padding: `${calcRemFn(4)} ${calcRemFn(35)} 0 ${calcRemFn(40)}`,
  },
  bottomBtnBaseCss: {
    width: calcRemFn(58),
    height: calcRemFn(24),
  }
}


const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      prodId: '27203',
      picNum: [2, 2, 2, 2, 2, 1, 2, 2, 2, 2],
    },
    {
      key: 'top2',
      show: true,
      prodId: '27378',
      picNum: [2, 2, 2, 1, 1, 2, 2, 2, 1, 1]
    },
    {
      key: 'top3',
      show: true,
      prodId: '27379',
      picNum: [2, 2, 1, 1, 2, 1, 1, 1, 2, 1]
    }
  ],
  bottom: {
    top1: [],
    top2: [],
    top3: []
  },
}
let sonTmp1 = new Array(10).fill(1)

navData.top = navData.top.map((item, index) => {
  item.img = require(`../../assets/autumnFlower/nav/far${index + 1}.png`)
  item.img_actived = require(`../../assets/autumnFlower/nav/far${index + 1}_active.png`)
  return item
})

sonTmp1.forEach((item, index) => {
  let flag = index + 1
  navData.bottom.top1.push({
    key: '_i' + flag,
    show: true,
    img: require(`../../assets/autumnFlower/nav/son${flag}.png`),
    img_actived: require(`../../assets/autumnFlower/nav/son${flag}_active.png`),
  })
  navData.bottom.top2.push({
    key: '_i' + flag,
    show: true,
    img: require(`../../assets/autumnFlower/nav/son${flag}.png`),
    img_actived: require(`../../assets/autumnFlower/nav/son${flag}_active.png`),
  })
  navData.bottom.top3.push({
    key: '_i' + flag,
    show: true,
    img: require(`../../assets/autumnFlower/nav/son${flag}.png`),
    img_actived: require(`../../assets/autumnFlower/nav/son${flag}_active.png`),
  })
})

function handlePictures () {
  const pictures = []
  navData.top.forEach((item, index) => {
    const { picNum, key } = item

    picNum.forEach((ele, eleIndex) => {
      const picList = []
      Array(ele).fill(0).forEach((ele2, eleIndex2) => {
        picList.push(require(`../../assets/autumnFlower/ctn/${index + 1}_${eleIndex + 1}_${eleIndex2 + 1}.jpg`))
        if (ele === (eleIndex2 + 1)) {
          pictures.push({
            id: item.prodId,
            type: 'gold',
            ref: `${key}_i${eleIndex + 1}`,
            farName: `${key}`,
            sonName: `_i${eleIndex + 1}`,
            son: picList
          })
        }
      })
    })

  })

  return pictures
}

const pictures = handlePictures()

pictures.push({
  son: [
    require(`../../assets/autumnFlower/ctn/end.jpg`),
  ]
})

const topDiff = {
  firstSon: '_i1',
  top1_i1: 15,
  top1_i4: -18,
  top1_i5: -18,
  top1_i6: -34,
  top1_i7: -14,
  top1_i8: -4,
  top1_i9: -5,
  top1_i10: -4,
  top2_i1: 20,
  top2_i2: 20,
  top2_i3: 16,
  top2_i4: 16,
  top2_i6: 16,
  top2_i7: 16,
  top2_i8: 15,
  top2_i9: 18,
  top2_i10: -2,
  top3_i1: -8,
  top3_i3: -8,
  top3_i4: 15,
  top3_i5: -6,
  top3_i7: 15,
  top3_i8: -1,
  top3_i10: 15,
}

export default {
  title: '花颜照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
